import { MerchantBrandItemOption } from "../../common";

export enum EGiftCardStatus {
  Active = "active",
  LowStock = "low_stock",
  OutOfStock = "out_of_stock",
  Expired = "expired",
}

export interface EGiftCardNumberRange {
  min: number | null;
  max: number | null;
}

export interface EGiftCardFilter {
  merchant_id?: string | null;
  merchant_name?: string | null;
  coupon_name?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  quantity?: EGiftCardNumberRange | null;
  use_per_customer?: EGiftCardNumberRange | null;
  used_quantity?: EGiftCardNumberRange | null;
  available_quantity?: EGiftCardNumberRange | null;
  points_required?: EGiftCardNumberRange | null;
  requested_status?: EGiftCardStatus | null;
  [key: string]: string | number | EGiftCardNumberRange | null | undefined;
}

export interface EGiftCardPagination {
  index: number;
  size: number;
}

export interface EGiftCardPaging {
  count: number;
  index: number;
  size: number;
  total: number;
}

export interface EGiftCardListItemResponse {
  used_quantity: number;
  quantity: number;
  available_quantity: number;
  is_alert_low_stock: boolean;
  status: EGiftCardStatus;
  id: string;
  image_url: string;
  title: string;
  merchant_id: string;
  merchant_name: string;
  points_required: number;
  valid_from: string;
  valid_to: string;
}

export interface MerchantEGiftCard extends MerchantBrandItemOption {
  quantity: number;
  coupon_id?: string;
  used_quantity?: number;
  disabled?: boolean | null;
  is_existing?: boolean;
}

export interface EGiftCardListResponse {
  pagination: EGiftCardPaging;
  list: EGiftCardListItemResponse[] | null;
}

export interface EGiftCardListRequestForAdmin {
  merchant_id?: string | null;
  point_from?: number | null;
  point_to?: number | null;
  quantity_from?: number | null;
  quantity_to?: number | null;
  start_date?: string | Date | null;
  end_date?: string | Date | null;
  exchange_from?: number | null;
  exchange_to?: number | null;
  remaining_from?: number | null;
  remaining_to?: number | null;
  status?: EGiftCardStatus | null;
  index: number;
  size: number;
}

export interface RestockEGiftCardRequest {
  coupon_id: string;
  coupon_name?: string;
  created_quantity?: number;
  available_quantity?: number;
  restock_quantity: number | null;
}

export interface RestockEGiftCardResponse {
  coupon_id: string;
  coupon_name?: string;
  created_quantity?: number;
  available_quantity?: number;
  restock_quantity: number | null;
  success?: boolean;
  message?: string;
}

export interface EGiftCardCreateItemRequest {
  coupon_id: string;
  quantity: number;
  points: number;
  price: number;
}

export interface EGiftCardUpdateItemRequest extends EGiftCardCreateItemRequest {
  merchant_brand_item_id: string;
}

export interface CreateEGiftCardPayload {
  merchant_brand_id: string;
  gift_cards: EGiftCardCreateItemRequest[];
  valid_from?: string;
  valid_to?: string;
  timezone: string;
  is_alert_low_stock: boolean | null;
}

export interface UpdateEGiftCardPayload {
  merchant_brand_id: string;
  gift_cards: EGiftCardUpdateItemRequest[];
  valid_from?: string;
  valid_to?: string;
  timezone: string;
  is_alert_low_stock: boolean | null;
}

export interface GetEGiftCardDetailResponse {
  value: number;
  quantity: number;
  used_quantity: number;
  is_available: boolean;
  is_alert_low_stock: boolean;
  reward_name: string;
  name: string;
  id: string;
  image_url: string | null;
  title: string;
  merchant_id: string;
  merchant_brand_item_id: string;
  merchant_name: string;
  points_required: number;
  valid_from: string | null;
  valid_to: string | null;
}

export interface EGiftCardStatisticsResponse {
  total_gift_card: number;
  total_exchanged: number;
  total_fund: number;
  total_low_stock: number;
  tango_balance: number;
  actual_spent: number;
  committed_amount: number;
  requested_amount: number;
  forecast_remaining: number;
  refund_amount: number;
  currency: string;
}

export interface EGiftCardAvailableBalanceResponse {
  organization_id: string;
  balance: number;
  currency: string;
}

export interface ExistingEGiftCardCampaignResponse {
  coupon_id: string;
  valid_from: string;
  valid_to: string;
}

export interface RefundInfo {
  refund_amount: number;
  current_total_funds: number;
  new_total_funds: number;
  currency: string;
}

export interface DeleteEGiftCardInfoResponse {
  coupon_id: string;
  merchant_name: string;
  coupon_title: string;
  coupon_value: number;
  total_quantity: number;
  redeemed_quantity: number;
  remaining_quantity: number;
  refund_info: RefundInfo;
}

export interface RecallEGiftCardResponse {
  success: boolean;
  refund_amount: number;
  refunded_quantity: number;
  message: string;
}

export interface UpsertEGiftCardResponse {
  success: boolean;
  message: string;
}
